/**
 * Promise that just waits X amount of milliseconds
 * @param ms
 */
export function sleep(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
}
